@if(event) {

<div class="w-full border rounded-md">
  <div
    (click)="show = !show"
    class="flex justify-between items-center text-white px-2 py-1 rounded-md"
    style="background: {{ event.color }}"
  >
    <p>{{ event.nombre }}</p>
    <i
      class="pi pi-angle-down transition-all duration-200"
      [ngClass]="{ 'rotate-180': show }"
    ></i>
  </div>

  <div class="hide" [ngClass]="{ show: show }">
    <div>
      <div class="p-2">
        @if(event.todoElDia) {
        <p>
          <b>Duración:</b>
          Todo el día
        </p>
        }@else {
        <p>
          <b>Hora de inicio:</b>
          {{ date | date : 'dd/MM/YYYY' }} {{ event.inicio | date : 'HH:mm' }}
        </p>
        <p>
          <b>Hora de finalización:</b>
          {{ date | date : 'dd/MM/YYYY' }} {{ event.fin | date : 'HH:mm' }}
        </p>
        }
        <p>
          <b>
            <i class="pi pi-bell"></i>
            Notificación:
          </b>
          {{ getAlert(event.alerta) }}
        </p>

        <p>
          <b>
            <i class="pi pi-replay"></i>
            Se repite:
          </b>
          {{ getRepeat(event.repetir) }}
        </p>

        <div class="flex justify-end gap-4 items-center">
          <button
            class="border border-primary-500 text-primary-500 hover:bg-primary-500 hover:text-white transition-all duration-200 py-2 px-3 rounded-md"
            (click)="remove(event.id)"
          >
            Borrar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<c-dialog #dialog />
}
